import { render, staticRenderFns } from "./TourCrud.vue?vue&type=template&id=03b3d090"
import script from "./TourCrud.vue?vue&type=script&lang=js"
export * from "./TourCrud.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports